// this function is used to remove null, undefined and empty strings from the filters object


export const cleanFilters = (filters: object) =>
  Object.fromEntries(
    Object.entries(filters).filter(
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      ([_, value]) => {
        if (value === null || value === "" || value === undefined) return false;
        if (Array.isArray(value) && value.length === 0) return false;
        return true;
      }
    )
  );



